import { AppFilter, AppTable, AppTableColumn } from '../../_models/models';
import {
  UniversalMediaListType,
  UniversalMediaListSegmentType
} from '@/app/features/universal-media-lists/universal-media-list-types.model';

export const universalMediaContentTable = new AppTable(
  'universalMediaContentTable',
  1,
  10,
  'domainBundle',
  'asc',
  true,
  true,
  '',
  [10, 20, 30, 40, 50],
  'ASC'
);

export const getUniversalMediaContentFilters = (): AppFilter[] => [
  new AppFilter(
    'mediaContentSearch',
    'SEARCH',
    'domainBundle',
    'Search App/Site Bundles',
    'Search for specific domains or bundles',
    'multiple',
    true,
    true
  )
];

export const getUniversalMediaContentTableColumns = (): AppTableColumn[] => [
  {
    id: 'domainBundle',
    prop: 'domainBundle',
    displayName: 'Site/App Bundle',
    type: 'text',
    isSortEnabled: true
  }
];

export const UNIVERSAL_MEDIA_CONTENT_MESSAGES = {
  loadError: 'Failed to load media content. Please try again.',
  noDataMessage: 'No media content found',
  loadingMessage: 'Loading media content...'
};

export const VIEW_BUTTON_RULES = {
  internalUserListTypes: [
    UniversalMediaListType.INTERNAL,
    UniversalMediaListType.SHARED
  ],
  externalUserListTypes: [
    UniversalMediaListType.CURATED_MARKETPLACE,
  ],
  externalUserMediaTypes: [
    UniversalMediaListSegmentType.MEDIA_DOMAIN,
    UniversalMediaListSegmentType.MEDIA_ID
  ]
};
